import security from 'stores/security';
import withPreload from 'utils/withPreload';

/**
 * @description
 * 获取用户资料，但是注意，用户资料获取成功后不会传递给子组件，需要从security中获取
 */
const withCustomInfo = withPreload<'customerInfo'>(() => security.getCustomerInfo(), {
    prop: 'customerInfo'
});

export default withCustomInfo;
